import { FONTSIZE_STORAGE } from '03CommonApiParts/CodeDefinition';
/*====== 画面Config ======*/
/*------ 画面遷移時間 ------*/
export const timeConfig = {
    snackbar:{//スナックバー表示から非表示までの時間(msec)
        success:2200,
        error:4200,
    },
    timer:60,//自動API処理までの時間(秒)
    dasfTimer:300//ダッシュボード自動A更新までの時間(秒)
};

/*------ sessionStorageから検索キー項目を取得 ------*/ 


// //セッションストレージから取得した値の更新で再レンダリング
// window.addEventListener('storage', () => {
//     console.log('セッションストレージの値が変更されました')
//     console.log(storageToken)
// });
	
// const storageToken ='medium';
/*------ フォントサイズ ------*/
const size = {
    large:{//大
        headText:'26px',
        titleText:'22px',
        baseText:'18px',
        inputlabelText:'14px',
        inputlabelTop:'-16px',
        buttonWidth:'150px',
        buttonHeight:'30px',
        iconButtonWidth:'35px',
        iconButtonHeight:'30px',
        dialogButtonWidth:'100px',
        dialogButtonHeight:'30px',
        inputHeight:'25px',
        categoryHeight:'330px',
        categoryWidth:'330px',
        fontsizeButtonTooltipText:'14px',
        svgHeight:'20px',
        svgWidth:'20px',
        tableSvgHeight:'30px',
        tableSvgWidth:'30px',
        anchorHeight:'32px',
        anchorWidth:'140px',
        tableCell:1.03,
        tableHeightsize:'calc(100vh - 210px)',
        tableSmallHeightsize:'calc(100vh - 395px)',
        tableSmallLabel :'14px',
        tableSmalSVG :'14px',
        leftTableCellL:'200px',
        leftTableCellR:'1695px',
        leftTableCellMinR: '500px',
        commentInputHeight:'23px',
        tagHeight:'28px',
        priorityTagWidth:'100px',
        statusTagWidth:'130px',

        formatButtonWidth:'270px',
        formatButtonHeight:'30px'


    },
    medium:{//中
       headText:'24px',
       titleText:'20px',
       baseText:'16px',
       inputlabelText:'12px',
       inputlabelTop:'-12px',
       buttonWidth:'125px',
       buttonHeight:'28px',
       iconButtonWidth:'35px',
       iconButtonHeight:'28px',
       dialogButtonWidth:'85px',
       dialogButtonHeight:'28px',
       inputHeight:'25px',
       categoryHeight:'310px',
       categoryWidth:'290px',
       fontsizeButtonTooltipText:'12px',
       svgHeight:'18px',
       svgWidth:'18px',
       tableSvgHeight:'28px',
       tableSvgWidth:'28px',
       anchorHeight:'30px',
       anchorWidth:'120px',
       tableCell:1,
       tableHeightsize:'calc(100vh - 200px)',
       tableSmallHeightsize:'calc(100vh - 380px)',
       tableSmallLabel :'12px',
       tableSmalSVG :'12px',
       leftTableCellL:'180px',
       leftTableCellR:'1695px',
       leftTableCellMinR: '420px',
       commentInputHeight:'21px',
       tagHeight:'24px',
       priorityTagWidth:'85px',
       statusTagWidth:'120px',
       formatButtonWidth:'250px',
       formatButtonHeight:'28px'


    },
    small:{//小
        headText:'22px',
        titleText:'18px',
        baseText:'14px',
        inputlabelText:'10px',
        inputlabelTop:'-11px',
        buttonWidth:'110px',
        buttonHeight:'25px',
        iconButtonWidth:'32px',
        iconButtonHeight:'25px',
        dialogButtonWidth:'75px',
        dialogButtonHeight:'25px',
        inputHeight:'20px',
        categoryHeight:'290px',
        categoryWidth:'260px',
        fontsizeButtonTooltipText:'10px',
        svgHeight:'15px',
        svgWidth:'15px',
        tableSvgHeight:'25px',
        tableSvgWidth:'25px',
        anchorHeight:'28px',
        anchorWidth:'100px',
        tableCell:0.97,
        tableHeightsize:'calc(100vh - 190px)',
        tableSmallHeightsize:0.8,
        tableSmallLabel :'10px',
        tableSmalSVG :'10px',
        leftTableCellL:'160px',
        leftTableCellR:'1715px',
        leftTableCellMinR: '390px',
        commentInputHeight:'19px',
        tagHeight:'20px',
        priorityTagWidth:'70px',
        statusTagWidth:'110px',

        formatButtonWidth:'220px',
        formatButtonHeight:'25px'
        
    }
}
/*------ style ------*/
export const assets = () => {
    const getStorageToken = localStorage.getItem(FONTSIZE_STORAGE);
    var css = {
        color:{//色
        base:'black',
        blue:'#2e94b9',
        green:'#70AD47',
        red:'#D45B5B',
        yellow:'#D7B026',
        lightYellow:'#ffffe0',
        gray:'#808080',
        lightGray:'#D3D3D3',
        lightBlue:'#73D2F0',
        pink:'#FF7D7D',
        orange:'#FAA578',
        border:'#CCCCCC',
        focusOutline:'#007BC3',
        fileBackground:'#EFEFEF', 
        disabled:'#d9d9d9',
        white:'#ffffff',
        whiteHover:'#EEEEEE',
        tableDisabled:'#e2e2e26a',
        blueHover:'#257694',
        snackbarSuccess:'#2E7D32',
        snackbarError:'#D32F2F',
        snackbarWarning:'#ED6C02',
        backgroudYellow:'#FFFBEC',
        backgroundBlue:'#edf4f7',//F4F8FA
        iconBlack:'#4b4b4b',
        placeholder:'#9c9c9c',
        dashbackgroud:'#d3e1ff',
        dashbordTitle:'#646667',
    },
    size:{//サイズ
        headText:size[getStorageToken?getStorageToken:'medium'].headText,
        titleText:size[getStorageToken?getStorageToken:'medium'].titleText,
        baseText:size[getStorageToken?getStorageToken:'medium'].baseText,
        inputlabelText:size[getStorageToken?getStorageToken:'medium'].inputlabelText,
        inputlabelTop:size[getStorageToken?getStorageToken:'medium'].inputlabelTop,
        buttonWidth:size[getStorageToken?getStorageToken:'medium'].buttonWidth,
        buttonHeight:size[getStorageToken?getStorageToken:'medium'].buttonHeight,
        iconButtonWidth:size[getStorageToken?getStorageToken:'medium'].iconButtonWidth,
        iconButtonHeight:size[getStorageToken?getStorageToken:'medium'].iconButtonHeight,
        dialogButtonWidth:size[getStorageToken?getStorageToken:'medium'].dialogButtonWidth,
        dialogButtonHeight:size[getStorageToken?getStorageToken:'medium'].dialogButtonHeight,
        inputHeight:size[getStorageToken?getStorageToken:'medium'].inputHeight,
        categoryHeight:size[getStorageToken?getStorageToken:'medium'].categoryHeight,
        categoryWidth:size[getStorageToken?getStorageToken:'medium'].categoryWidth,
        fontsizeButtonTooltipText:size[getStorageToken?getStorageToken:'medium'].fontsizeButtonTooltipText,
        svgHeight:size[getStorageToken?getStorageToken:'medium'].svgHeight,
        svgWidth:size[getStorageToken?getStorageToken:'medium'].svgWidth,
        tableSvgHeight:size[getStorageToken?getStorageToken:'medium'].tableSvgHeight,
        tableSvgWidth:size[getStorageToken?getStorageToken:'medium'].tableSvgWidth,
        anchorHeight:size[getStorageToken?getStorageToken:'medium'].anchorHeight,
        anchorWidth:size[getStorageToken?getStorageToken:'medium'].anchorWidth,
        tableCell:size[getStorageToken?getStorageToken:'medium'].tableCell,
        tableHeightsize:size[getStorageToken?getStorageToken:'medium'].tableHeightsize,
        tableSmallLabel:size[getStorageToken?getStorageToken:'medium'].tableSmallLabel,
        tableSmalSVG:size[getStorageToken?getStorageToken:'medium'].tableSmalSVG,
        leftTableCellL:size[getStorageToken?getStorageToken:'medium'].leftTableCellL,
        leftTableCellR:size[getStorageToken?getStorageToken:'medium'].leftTableCellR,
        commentInputHeight:size[getStorageToken?getStorageToken:'medium'].commentInputHeight,
        tagHeight:size[getStorageToken?getStorageToken:'medium'].tagHeight,
        priorityTagWidth:size[getStorageToken?getStorageToken:'medium'].priorityTagWidth,
        statusTagWidth:size[getStorageToken?getStorageToken:'medium'].statusTagWidth,

        formatButtonWidth:size[getStorageToken?getStorageToken:'medium'].formatButtonWidth,
        formatButtonHeight:size[getStorageToken?getStorageToken:'medium'].formatButtonHeight,


    },
    large:size.large,
    medium:size.medium,
    small:size.small}
    return css;
};



